type ValorSolicitud = string | number | boolean | null | readonly ValorSolicitud[] |
  { readonly [campo: string]: ValorSolicitud };

export const RPC_SOLICITUDES_ACTIVIDAD: Readonly<Record<string, string>> = {
  crear_producto: 'crear_producto_actividad', editar_producto: 'editar_producto_actividad', eliminar_producto: 'eliminar_producto_actividad',
  crear_produccion: 'crear_produccion_actividad', editar_produccion: 'editar_produccion_actividad', eliminar_produccion: 'eliminar_produccion_actividad',
  editar_venta: 'editar_venta_actividad', editar_costo: 'editar_costo_actividad',
  crear_pedido_actividad: 'crear_pedido_actividad', crear_costo_actividad: 'crear_costo_actividad',
  registrar_pago_pedido_actividad: 'registrar_pago_pedido_actividad', registrar_entrega_pedido_actividad: 'registrar_entrega_pedido_actividad',
  anular_venta_actividad: 'anular_venta_actividad', anular_costo_actividad: 'anular_costo_actividad',
  eliminar_actividad: 'eliminar_actividad', reembolsar_movimiento: 'reembolsar_movimiento', adjuntar_comprobantes: 'adjuntar_comprobantes',
};

/** Se crea y conserva en el formulario ANTES de llamar al servicio. No contiene JWT. */
export interface SolicitudActividad {
  readonly id: string;
  readonly rpc: string;
  readonly operacion: string;
  readonly argumentos: Readonly<Record<string, ValorSolicitud>>;
  readonly argumentosContrato: Readonly<Record<string, ValorSolicitud>>;
}

export function congelarSolicitudActividad(solicitud: SolicitudActividad): SolicitudActividad {
  congelar(solicitud.argumentos);
  congelar(solicitud.argumentosContrato);
  return Object.freeze(solicitud);
}

function congelar(valor: ValorSolicitud): void {
  if (valor !== null && typeof valor === 'object') {
    Object.values(valor).forEach(congelar);
    Object.freeze(valor);
  }
}

/** Snapshot JSON independiente del estado editable; conserva IDs/fechas/payload. */
export function prepararSolicitudActividad(
  rpc: string, operacion: string, argumentos: Readonly<Record<string, unknown>>,
  argumentosContrato: Readonly<Record<string, unknown>>,
): SolicitudActividad {
  if (!Object.prototype.hasOwnProperty.call(RPC_SOLICITUDES_ACTIVIDAD, operacion)
    || RPC_SOLICITUDES_ACTIVIDAD[operacion] !== rpc) {
    throw new Error('La operación no tiene un contrato de solicitud válido.');
  }
  if (Object.prototype.hasOwnProperty.call(argumentos, 'p_solicitud')) {
    throw new Error('La solicitud no se incluye dentro de sus argumentos.');
  }
  const serializado = JSON.stringify({ argumentos, argumentosContrato }, (_campo: string, valor: unknown) => {
    if (typeof valor === 'number' && !Number.isFinite(valor)) {
      throw new Error('Los argumentos de la solicitud requieren importes finitos.');
    }
    if (typeof valor === 'bigint' || typeof valor === 'function' || typeof valor === 'symbol') {
      throw new Error('Los argumentos de la solicitud deben ser datos JSON.');
    }
    return valor;
  });
  const copia = JSON.parse(serializado) as {
    argumentos: Record<string, ValorSolicitud>; argumentosContrato: Record<string, ValorSolicitud>;
  };
  congelar(copia.argumentos);
  congelar(copia.argumentosContrato);
  return Object.freeze({ id: crypto.randomUUID(), rpc, operacion, ...copia });
}

/** Rechazos DB que confirman fallo de la transacción; red/respuesta vacía no bastan. */
export function rechazoConfirmadoActividad(error: unknown): boolean {
  if (error === null || typeof error !== 'object' || !('code' in error) || typeof error.code !== 'string') return false;
  return /^(P0001|P0002|22[0-9A-Z]{3}|23[0-9A-Z]{3}|42501|40001|40P01)$/.test(error.code);
}

export class ResultadoActividadInciertoError extends Error {
  readonly solicitud: SolicitudActividad;
  readonly detalle: unknown;

  constructor(solicitud: SolicitudActividad, detalle: unknown) {
    super('No pudimos confirmar el resultado. Verifica esta operación antes de registrar otra.');
    this.name = 'ResultadoActividadInciertoError';
    this.solicitud = solicitud;
    this.detalle = detalle;
  }
}
